export const defaultFilter = () => {
    return {
        company_id: null,
        slq_location_id: null,
        type: null,
        page: 1,
        per_page: 10,
    }
}

export default {
    processSecurity: [],
    preventionPolicies: [],
    filter: defaultFilter(),
    procesDetails: null,
    procesDetailsPrePol: null,
    attachments: [],
    modulesOnlyFile: [
        'instalaciónes-clasificadas',
        'registro-de-divulgación',
        'diagrama-de-bloques-o-de-flujo-del-proceso',
        'química-de-los-procesos-cinéticas',
        'inventario-máximo-previsto',
        'límites-de-diseño-de-las-variables-del-proceso',
        'evaluación-de-consecuencias-de-las-desviaciones',
        'información-de-los-materiales-de-construcción',
        'información-de-los-materiales-de-construcción',
        'diagramas-de-instrumentación-y-tubería-P&IDs',
        'información-de-clasificación-eléctrica',
        'información-de-diseño-de-los-sistemas-de-alivio-y-de-ventilación',
        'información-de-códigos-y-estándares-de-diseño-utilizados',
        'información-de-balances-de-materia-y-energía-de-los-procesos',
        'información-de-sistemas-de-seguridad',
        'información-de-identificación-de-amenazas-naturales-presentes-en-el-territorio',
        'factores-internos-de-la-instalación-clasificada',
        'factores-externos-de-la-instalación-clasificada',
        'objetivos-del proceso-de-gestión-de-riesgos',
        'definición-de-criterios-de-aceptación-del-riesgo-individual',
        'desarrollo-de-análisis-pha-cualitativos',
        'desarrollo-de-análisis-pha-cuantitativos',
        'divulgación-socialización-de-los-escenarios-de-riesgos-identificados-en-los-estudios-pha',
        'comunicación-y-consulta',
        'planes-de-acción-y-priorización-de-las-recomendaciones-resultantes-de-los-análisis-pha',
        'pec',
        'simulaciones-y-simulacro',
        'participación-de-los-trabajadores',
        'procedimientos-de-operación',
        'entrenamiento',
        'revisión-de-seguridad-pre-arranque',
        'integridad-mecánica',
        'permisos-de-trabajo',
        'gestión-del-cambio',
        'indicadores-de-desempeño',
        'auditorias-de-cumplimiento',
        'revisión-por-la-dirección',
        'registro-de-incidentes',
        'reporte-de-accidentes-mayores',
        'informe-de-seguridad',
        'inspección-vigilancia-y-control-ivc',
        'información-disponible-al-público',
        'intercambio-de-información-relacionada-con-accidentes-mayores-que-puedan-tener-impacto-transfronterizo',
        'información-con-fines-de-gestión-territorial-del-riesgo',
        'información-con-fines-de-ordenamiento-territorial',
    ],
    currentType: 'objetivo',
    components: [
        {
            type: 'objetivo',
            title: 'Objetivo',
        },
        {
            type: 'alcance',
            title: 'Alcance',
        },
        {
            type: 'introducción',
            title: 'Introducción',
        },
        {
            type: 'justificación',
            title: 'Justificación',
        },
        {
            type: 'instalaciónes-clasificadas',
            title: 'Instalaciónes Clasificadas',
        },
        {
            type: 'política',
            title: 'Política',
        },
        {
            type: 'registro-de-divulgación',
            title: 'Registro de divulgación',
        },
        {
            type: 'diagrama-de-bloques-o-de-flujo-del-proceso',
            title: 'Información de seguridad - Carga de información',
            children: [
                {
                    title: 'Diagrama de bloques o de flujo del proceso',
                    type: 'diagrama-de-bloques-o-de-flujo-del-proceso'
                },
                {
                    title: 'Química de los procesos (cinéticas)',
                    type: 'química-de-los-procesos-cinéticas'
                },
                {
                    title: 'Inventario máximo previsto',
                    type: 'inventario-máximo-previsto'
                },
                {
                    title: 'Límites de diseño de las variables del proceso',
                    type: 'límites-de-diseño-de-las-variables-del-proceso'
                },
                {
                    title: 'Evaluación de consecuencias de las desviaciones',
                    type: 'evaluación-de-consecuencias-de-las-desviaciones'
                },
                {
                    title: 'Inf de los materiales de construcción',
                    type: 'información-de-los-materiales-de-construcción'
                },
                {
                    title: 'Diagramas de instrumentación y tubería (P&IDs)',
                    type: 'diagramas-de-instrumentación-y-tubería-P&IDs'
                },
                {
                    title: 'Inf de clasificación eléctrica',
                    type: 'información-de-clasificación-eléctrica'
                },
                {
                    title: 'Inf de diseño de los sistemas de alivio y de ventilación',
                    type: 'información-de-diseño-de-los-sistemas-de-alivio-y-de-ventilación'
                },
                {
                    title: 'Inf de códigos y estándares de diseño utilizados',
                    type: 'información-de-códigos-y-estándares-de-diseño-utilizados'
                },
                {
                    title: 'Inf de balances de materia y energía de los proceso',
                    type: 'información-de-balances-de-materia-y-energía-de-los-procesos'
                },
                {
                    title: 'Inf de sistemas de Seguridad',
                    type: 'información-de-sistemas-de-seguridad'
                },
                {
                    title: 'Inf de identificación de amenazas naturales presentes en el territorio',
                    type: 'información-de-identificación-de-amenazas-naturales-presentes-en-el-territorio'
                },
            ],
        },
        {
            type: 'factores-internos-de-la-instalación-clasificada',
            title: 'Identificación de peligros análisis y evaluación de riesgo',
            children: [
                {
                    title: 'Factores internos de la instalación clasificada',
                    type: 'factores-internos-de-la-instalación-clasificada',
                },
                {
                    title: 'Factores externos de la instalación clasificada',
                    type: 'factores-externos-de-la-instalación-clasificada',
                },
                {
                    title: 'Objetivos del proceso de gestión de riesgos',
                    type: 'objetivos-del proceso-de-gestión-de-riesgos',
                },
                {
                    title: 'Definición de criterios de aceptación',
                    type: 'definición-de-criterios-de-aceptación-del-riesgo-individual',
                },
                {
                    title: 'Desarrollo de análisis PHA cualitativos',
                    type: 'desarrollo-de-análisis-pha-cualitativos'
                },
                {
                    title: 'Desarrollo de análisis PHA cuantitativos',
                    type: 'desarrollo-de-análisis-pha-cuantitativos'
                },
                {
                    title: 'Divulgación/Socialización de los escenarios de riesgos identificados en los estudios PHA',
                    type: 'divulgación-socialización-de-los-escenarios-de-riesgos-identificados-en-los-estudios-pha'
                },
                {
                    title: 'Comunicación y consulta',
                    type: 'comunicación-y-consulta'
                },
                {
                    title: 'Planes de acción y priorización de las recomendaciones resultantes de los análisis PHA',
                    type: 'planes-de-acción-y-priorización-de-las-recomendaciones-resultantes-de-los-análisis-pha'
                },
            ]
        },

        {
            title: 'Plan de emergencias y contingencias (PEC)',
            type: 'pec',
            children: [
                {
                    title: 'PEC',
                    type: 'pec',
                },
                {
                    title: 'Simulaciones y Simulacro',
                    type: 'simulaciones-y-simulacro',
                },
            ],
        },
        {
            title: 'Sistema de Gestión de la Seguridad para la Prevención de Accidentes Mayores',
            type: 'participación-de-los-trabajadores',
            children: [
                {
                    title: 'Participación de los trabajadores',
                    type: 'participación-de-los-trabajadores',
                },
                {
                    title: 'Procedimientos de operación',
                    type: 'procedimientos-de-operación',
                },
                {
                    title: 'Entrenamiento',
                    type: 'entrenamiento',
                },
                {
                    title: 'Revisión de seguridad pre-arranque',
                    type: 'revisión-de-seguridad-pre-arranque',
                },
                {
                    title: 'Integridad mecánica',
                    type: 'integridad-mecánica',
                },
                {
                    title: 'Permisos de trabajo',
                    type: 'permisos-de-trabajo',
                },
                {
                    title: 'Gestión del cambio',
                    type: 'gestión-del-cambio',
                },
                {
                    title: 'Indicadores de desempeño',
                    type: 'indicadores-de-desempeño',
                },
                {
                    title: 'Auditorias de cumplimiento',
                    type: 'auditorias-de-cumplimiento',
                },
                {
                    title: 'Revisión por la dirección',
                    type: 'revisión-por-la-dirección',
                },
            ]
        },
        {
            title: 'Investigación de incidentes y accidentes mayores',
            type: 'registro-de-incidentes',
            children: [
                {
                    title: 'Registro de incidentes',
                    type: 'registro-de-incidentes',
                },
                {
                    title: 'Reporte de accidentes mayores',
                    type: 'reporte-de-accidentes-mayores',
                }
            ]
        },
        {
            title: 'Informe de seguridad',
            type: 'informe-de-seguridad'
        },
        {
            title: 'Inspección vigilancia y control-ivc',
            type: 'inspección-vigilancia-y-control-ivc'
        },
        {
            title: 'Información disponible al público',
            type: 'información-disponible-al-público'
        },
        {
            title: 'Intercambio info relacionada accidentes mayores con impacto transfronterizo',
            type: 'intercambio-de-información-relacionada-con-accidentes-mayores-que-puedan-tener-impacto-transfronterizo'
        },
        {
            title: 'Información con fines de gestión territorial del riesgo',
            type: 'información-con-fines-de-gestión-territorial-del-riesgo'
        },
        {
            title: 'Información con fines de ordenamiento territorial',
            type: 'información-con-fines-de-ordenamiento-territorial'
        },
    ],
    modules: [
        {
            title: 'Diagrama de bloques o de flujo del proceso',
            type: 'diagrama-de-bloques-o-de-flujo-del-proceso'
        },
        {
            title: 'Química de los procesos (cinéticas)',
            type: 'química-de-los-procesos-cinéticas'
        },
        {
            title: 'Inventario máximo previsto',
            type: 'inventario-máximo-previsto'
        },
        {
            title: 'Límites de diseño de las variables del proceso',
            type: 'límites-de-diseño-de-las-variables-del-proceso'
        },
        {
            title: 'Evaluación de consecuencias de las desviaciones',
            type: 'evaluación-de-consecuencias-de-las-desviaciones'
        },
        {
            title: 'Inf de los materiales de construcción',
            type: 'información-de-los-materiales-de-construcción'
        },
        {
            title: 'Diagramas de instrumentación y tubería (P&IDs)',
            type: 'diagramas-de-instrumentación-y-tubería-P&IDs'
        },
        {
            title: 'Inf de clasificación eléctrica',
            type: 'información-de-clasificación-eléctrica'
        },
        {
            title: 'Inf de diseño de los sistemas de alivio y de ventilación',
            type: 'información-de-diseño-de-los-sistemas-de-alivio-y-de-ventilación'
        },
        {
            title: 'Inf de códigos y estándares de diseño utilizados',
            type: 'información-de-códigos-y-estándares-de-diseño-utilizados'
        },
        {
            title: 'Inf de balances de materia y energía de los proceso',
            type: 'información-de-balances-de-materia-y-energía-de-los-procesos'
        },
        {
            title: 'Inf de sistemas de Seguridad',
            type: 'información-de-sistemas-de-seguridad'
        },
        {
            title: 'Inf de identificación de amenazas naturales presentes en el territorio',
            type: 'información-de-identificación-de-amenazas-naturales-presentes-en-el-territorio'
        },
    ],
    modules_danger_risk: [
        {
            title: 'Factores internos de la instalación clasificada',
            type: 'factores-internos-de-la-instalación-clasificada',
        },
        {
            title: 'Factores externos de la instalación clasificada',
            type: 'factores-externos-de-la-instalación-clasificada',
        },
        {
            title: 'Objetivos del proceso de gestión de riesgos',
            type: 'objetivos-del proceso-de-gestión-de-riesgos',
        },
        {
            title: 'Definición de criterios de aceptación',
            type: 'definición-de-criterios-de-aceptación-del-riesgo-individual',
        },
        {
            title: 'Desarrollo de análisis PHA cualitativos',
            type: 'desarrollo-de-análisis-pha-cualitativos'
        },
        {
            title: 'Desarrollo de análisis PHA cuantitativos',
            type: 'desarrollo-de-análisis-pha-cuantitativos'
        },
        {
            title: 'Divulgación/Socialización de los escenarios de riesgos identificados en los estudios PHA',
            type: 'divulgación-socialización-de-los-escenarios-de-riesgos-identificados-en-los-estudios-pha'
        },
        {
            title: 'Comunicación y consulta',
            type: 'comunicación-y-consulta'
        },
        {
            title: 'Planes de acción y priorización de las recomendaciones resultantes de los análisis PHA',
            type: 'planes-de-acción-y-priorización-de-las-recomendaciones-resultantes-de-los-análisis-pha'
        },
    ],
    dataPercentage: [],
    modules_danger_risk_items: [
        {
            title: 'Contexto para la gestión de los riesgos de la instalación',
            type: 'factores-internos-de-la-instalación-clasificada',
            children: [
                {
                    title: 'Factores internos de la instalación clasificada',
                    type: 'factores-internos-de-la-instalación-clasificada',
                },
                {
                    title: 'Factores externos de la instalación clasificada',
                    type: 'factores-externos-de-la-instalación-clasificada',
                },
                {
                    title: 'Objetivos del proceso de gestión de riesgos',
                    type: 'objetivos-del proceso-de-gestión-de-riesgos',
                },
                {
                    title: 'Definición de criterios de aceptación',
                    type: 'definición-de-criterios-de-aceptación-del-riesgo-individual',
                }
            ]
        },
        {
            title: 'Estandares y metodologías PHA (Process Hazard Analysis) a implementar en la instalación clasificada',
            type: 'desarrollo-de-análisis-pha-cualitativos',
            children: [
                {
                    title: 'Desarrollo de análisis PHA cualitativos',
                    type: 'desarrollo-de-análisis-pha-cualitativos',
                },
                {
                    title: 'Desarrollo de análisis PHA cuantitativos',
                    type: 'desarrollo-de-análisis-pha-cuantitativos'
                },
                {
                    title: 'Divulgación/Socialización de los escenarios de riesgos identificados en los estudios PHA',
                    type: 'divulgación-socialización-de-los-escenarios-de-riesgos-identificados-en-los-estudios-pha'
                },
                {
                    title: 'Comunicación y consulta',
                    type: 'comunicación-y-consulta'
                },
                {
                    title: 'Planes de acción y priorización de las recomendaciones resultantes de los análisis PHA',
                    type: 'planes-de-acción-y-priorización-de-las-recomendaciones-resultantes-de-los-análisis-pha'
                },
            ]
        }
    ],
    modules_pha: ['desarrollo-de-análisis-pha-cuantitativos', 'desarrollo-de-análisis-pha-cualitativos'],
    options_types: [],
    other_modules: [
        {
            title: 'Plan de emergencias y contingencias (PEC)',
            type: 'pec',
            children: [
                {
                    title: 'PEC',
                    type: 'pec',
                },
                {
                    title: 'Simulaciones y Simulacro',
                    type: 'simulaciones-y-simulacro',
                },
            ],
        },
        {
            title: 'Sistema de Gestión de la Seguridad para la Prevención de Accidentes Mayores',
            type: 'participación-de-los-trabajadores',
            children: [
                {
                    title: 'Participación de los trabajadores',
                    type: 'participación-de-los-trabajadores',
                },
                {
                    title: 'Procedimientos de operación',
                    type: 'procedimientos-de-operación',
                },
                {
                    title: 'Entrenamiento',
                    type: 'entrenamiento',
                },
                {
                    title: 'Revisión de seguridad pre-arranque',
                    type: 'revisión-de-seguridad-pre-arranque',
                },
                {
                    title: 'Integridad mecánica',
                    type: 'integridad-mecánica',
                },
                {
                    title: 'Permisos de trabajo',
                    type: 'permisos-de-trabajo',
                },
                {
                    title: 'Gestión del cambio',
                    type: 'gestión-del-cambio',
                },
                {
                    title: 'Indicadores de desempeño',
                    type: 'indicadores-de-desempeño',
                },
                {
                    title: 'Auditorias de cumplimiento',
                    type: 'auditorias-de-cumplimiento',
                },
                {
                    title: 'Revisión por la dirección',
                    type: 'revisión-por-la-dirección',
                },
            ]
        },
        {
            title: 'Investigación de incidentes y accidentes mayores',
            type: 'registro-de-incidentes',
            children: [
                {
                    title: 'Registro de incidentes',
                    type: 'registro-de-incidentes',
                },
                {
                    title: 'Reporte de accidentes mayores',
                    type: 'reporte-de-accidentes-mayores',
                }
            ]
        },
        {
            title: 'Informe de seguridad',
            type: 'informe-de-seguridad'
        },
        {
            title: 'Inspección vigilancia y control-ivc',
            type: 'inspección-vigilancia-y-control-ivc'
        },
        {
            title: 'Información disponible al público',
            type: 'información-disponible-al-público'
        },
        {
            title: 'Intercambio de información relacionada con accidentes mayores que puedan tener impacto transfronterizo',
            type: 'intercambio-de-información-relacionada-con-accidentes-mayores-que-puedan-tener-impacto-transfronterizo'
        },
        {
            title: 'Información con fines de gestión territorial del riesgo',
            type: 'información-con-fines-de-gestión-territorial-del-riesgo'
        },
        {
            title: 'Información con fines de ordenamiento territorial',
            type: 'información-con-fines-de-ordenamiento-territorial'
        },
    ],
    other_modules_items: [
        'pec',
        'simulaciones-y-simulacro',
        'participación-de-los-trabajadores',
        'procedimientos-de-operación',
        'entrenamiento',
        'revisión-de-seguridad-pre-arranque',
        'integridad-mecánica',
        'permisos-de-trabajo',
        'gestión-del-cambio',
        'indicadores-de-desempeño',
        'auditorias-de-cumplimiento',
        'revisión-por-la-dirección',
        'registro-de-incidentes',
        'reporte-de-accidentes-mayores',
    ]
}
